import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AppSidebar from '../AppSidebar';
import { Navbar } from '../common/Catalyst/navbar';
import { SidebarLayout } from '../common/Catalyst/sidebar-layout';

/**
 * The sidebar item a URL belongs to, as each page names it to
 * `AppSidebar`: the first path segment, with an association's own pages
 * (`/hoa/…`) under HOAs.
 */
export const sidebarPageFor = (pathname: string): string => {
  const first = pathname.split('/')[1] ?? '';
  return first === 'hoa' ? 'hoas' : first;
};

/** A hold usually ends before anyone would notice; say so only after this. */
const SAY_LOADING_AFTER_MS = 800;

/**
 * What the signed-in app shows while it waits for its first copy from the
 * sync engine (`SyncHold`, #667): the shell every page sits in, with the
 * sidebar it will have, and nothing yet in the panel.
 *
 * It used to be a spinner in place of everything, so signing in went from
 * the sign-in page's shell to a bare canvas and back to a shell. Now the
 * shell stays and only the panel fills in.
 */
export const HeldShell: React.FC = () => {
  const { pathname } = useLocation();
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setSlow(true), SAY_LOADING_AFTER_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <SidebarLayout
      sidebar={<AppSidebar currentPage={sidebarPageFor(pathname)} />}
      navbar={<Navbar />}
    >
      {slow && (
        <p role="status" className="py-24 text-center text-[13px]/5 text-fg-muted">
          Loading…
        </p>
      )}
    </SidebarLayout>
  );
};

export default HeldShell;
